import {
  getProductPagingList,
  getProductDetail,
  getProductListCondition,
  getProductCondition,
  getProductLabelList
} from '@/api/product'
import { districtId } from '@/constant/index'
import { broadcastScrollHeight } from '@/utils/broadcastScrollHeight'
import { setNumberFixed } from '@/utils/format'
const state = {
  productList: [],
  filterCondition: null,
  totalCount: 0,
  // 产品详情
  productDetail: null,
  // 查询条件
  listCondition: null,
  // 产品的条件
  productCondition: null,
  // 发起融资填的条件
  financingCondition: null,
  // 标签列表
  labelList: [],
  currentLabel: null
}

const mutations = {
  SET_FILTER_CONDITION (state, filterCondition) {
    state.filterCondition = filterCondition
  },
  SET_PRODUCT_LIST (state, productList) {
    state.productList = productList
  },
  SET_TOTAL_COUNT (state, totalCount) {
    state.totalCount = parseInt(totalCount)
  },
  // 设置产品详情
  SET_PRODUCT_DETAIL: (state, detail) => {
    state.productDetail = detail
  },
  SET_LIST_CONDITION: (state, listCondition) => {
    state.listCondition = listCondition
  },
  SET_PRODUCT_CONDITION: (state, condition) => {
    state.productCondition = condition
  },
  SET_FINANCING_CONDITION: (state, financingCondition) => {
    state.financingCondition = financingCondition
  },
  SET_LABEL_LIST: (state, list) => {
    state.labelList = list
  },
  SET_CURRENT_LABEL: (state, label) => {
    state.currentLabel = label
  }
}

function formatParams (payLoad) {
  return {
    pageNo: 1,
    pageSize: 5,
    districtId: districtId, // 默认districtId
    ...payLoad
  }
}
const actions = {
  async getProductPagingList ({ commit, rootState }, params) {
    // 获取districtId
    // eslint-disable-next-line no-shadow
    let districtId = ''
    if (rootState.user.cityInfo.city) {
      districtId = rootState.user.cityInfo.city.id
    }
    if (rootState.user.cityInfo.district) {
      districtId = rootState.user.cityInfo.district.id
    }
    if (districtId) {
      params = {
        districtId,
        ...params
      }
    }
    const payLoad = formatParams(params)
    const res = await getProductPagingList(payLoad)
    let { code, data } = res.data
    if (code === 0) {
      data.result.forEach(item => {
        item.annualInterestRangeStart = setNumberFixed(item.annualInterestRangeStart, 2)
        item.annualInterestRangeEnd = setNumberFixed(item.annualInterestRangeEnd, 2)
      })
      commit('SET_TOTAL_COUNT', data.totalCount)
      commit('SET_PRODUCT_LIST', data.result)
    }
    // 获取列表后计算scrollHeight，告知父级
    setTimeout(broadcastScrollHeight, 0)
    return res
  },
  // 获取 产品详情
  async getProductDetail ({ commit }, id) {
    const response = await getProductDetail(id)
    const { code, data } = response.data
    if (code === 0) {
      data.annualInterestRangeStart = setNumberFixed(data.annualInterestRangeStart, 2)
      data.annualInterestRangeEnd = setNumberFixed(data.annualInterestRangeEnd, 2)
      commit('SET_PRODUCT_DETAIL', data)
    } else {
      commit('SET_PRODUCT_DETAIL', {})
    }
    // 获取详情后计算scrollHeight，告知父级
    setTimeout(broadcastScrollHeight, 0)
    return response
  },
  async getProductListCondition ({ state, commit }, param) {
    const response = await getProductListCondition(param)
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_LIST_CONDITION', data)
    } else {
      commit('SET_LIST_CONDITION', {})
    }
    return response
  },
  // 获取 贷款产品详细信息所需要的 字典数据
  async getProductCondition ({ commit }) {
    const response = await getProductCondition()
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_PRODUCT_CONDITION', data)
    } else {
      commit('SET_PRODUCT_CONDITION', [])
    }
    return response
  },
  async getProductLabelList ({ rootState, commit }) {
    let districtId = ''
    if (rootState.user.cityInfo.city) {
      districtId = rootState.user.cityInfo.city.id
    }
    if (rootState.user.cityInfo.district) {
      districtId = rootState.user.cityInfo.district.id
    }
    const response = await getProductLabelList(districtId)
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_LABEL_LIST', data)
    }
    return response
  },
  setCurrentLabel ({ commit }, label) {
    commit('SET_CURRENT_LABEL', label)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
